import React from 'react'
import '../Results.css'
import './AdminDrawer.css'
import { useState } from 'react'
import Drawer from './Drawer'
import { useEffect } from 'preact/hooks'
import endpoints from '../endpoints.json'

function createOptionsAdmin(values) {
  var options = []
  for (let i = 0; i < values.length; i++) {
    var col = {
      value: values[i],
      text: values[i],
      icons: [
        {
          name: 'cancel',
          position: 'after'
        }
      ]
    }
    options.push(col)
  }
  return options
}

const searchContextOptions = [
  { value: 'document', text: 'Document Search' },
  { value: 'sql', text: 'Data search' },
  { value: 'translate', text: 'Translate' },
  { value: 'web', text: 'Web' }
]

const temperatureOptions = [
  { value: 0.3, text: 'Very Strict' },
  { value: 0.5, text: 'Strict' },
  { value: 0.7, text: 'Balanced' },
  { value: 0.9, text: 'Creative' },
  { value: 1.1, text: 'Very Creative' }
]

const llmOptions = [
  { value: 'gpt-4o', text: 'GPT-4o' },
  { value: 'gpt-4o-mini', text: 'GPT-4o Mini' }
]

const AdminDrawer = ({ isDrawerOpen, closeDrawerFunc, adminConfig, setAdminConfig, userMail, index }) => {
  var temp_user = ''
  try {
    temp_user = userMail.split('.')[0].charAt(0).toUpperCase() + userMail.split('.')[0].slice(1)
  } catch {
    temp_user = 'non-verified'
  }
  const [user, setUser] = useState(temp_user)
  const [adminInput, setAdminInput] = useState('')
  const [defaultSystemMessage, setDefaultSystemMessage] = useState(adminConfig.systemMessage)
  const [startMessage, setStartMessage] = useState(adminConfig.startMessage)

  //const searchContextOptions = ['document', 'sql', 'translate', 'web']
  const updateAdminConfig = async (temp_admin_config) => {
    console.log(temp_admin_config)
    const response = await window.PDR.api.post(`${endpoints[window.location.host]}/updateAdmin`, {
      adminConfig: temp_admin_config
    })
  }

  const handleSystemMessageChange = (event) => {
    setDefaultSystemMessage(event.target.value)
  }

  const handleStartMessageChange = (event) => {
    setStartMessage(event.target.value)
  }

  const handleAddAdmin = () => {
    if (adminInput === '') {
      return
    }

    var temp = adminConfig
    temp.admins.push(adminInput)
    setAdminConfig(temp)
    setAdminInput('')
    updateAdminConfig(temp)
  }

  const handleAdminInput = (event) => {
    setAdminInput(event.target.value)
  }

  const removeAdmin = (admin) => {
    console.log(adminConfig.admins)
    var temp = { ...adminConfig }
    temp.admins = temp.admins.filter((a) => a !== admin)
    console.log('Removed admin:', admin)
    console.log('Admins:', temp.admins)
    setAdminConfig(temp)
    updateAdminConfig(temp)
  }

  const handleChangeAllowedSearchContext = (event) => {
    console.log(event.target.value)
    if (event.target.value.length === 0) {
      console.log('Empty')
      setAdminConfig({ ...adminConfig, allowedSearchContext: adminConfig.allowedSearchContext })
      setAdminConfig({ ...adminConfig, defaultSearchContext: adminConfig.defaultSearchContext })

      var temp = {
        ...adminConfig,
        allowedSearchContext: adminConfig.allowedSearchContext,
        defaultSearchContext: adminConfig.defaultSearchContext
      }
      updateAdminConfig(temp)
      return
    }

    if (!event.target.value.includes(adminConfig.defaultSearchContext)) {
      console.log('Not in default')
      setAdminConfig({
        ...adminConfig,
        defaultSearchContext: event.target.value[0],
        allowedSearchContext: event.target.value
      })
      return
    }
    setAdminConfig({ ...adminConfig, allowedSearchContext: event.target.value })
    updateAdminConfig({ ...adminConfig, allowedSearchContext: event.target.value })
  }

  const handleChangeDefaultSearchContext = (event) => {
    if (!adminConfig.allowedSearchContext.includes(event.target.value[0])) {
      setAdminConfig({ ...adminConfig, defaultSearchContext: adminConfig.allowedSearchContext[0] })
      updateAdminConfig({ ...adminConfig, defaultSearchContext: adminConfig.allowedSearchContext[0] })
      return
    }
    setAdminConfig({ ...adminConfig, defaultSearchContext: event.target.value[0] })
    updateAdminConfig({ ...adminConfig, defaultSearchContext: event.target.value[0] })
  }

  const handleChangeDefaultLLM = (event) => {
    if (!event.target.value.includes('gpt-4-turbo')) {
      setAdminConfig({ ...adminConfig, allowedLLMs: adminConfig.allowedLLMs })
      return
    }
    setAdminConfig({ ...adminConfig, allowedLLMs: event.target.value })
    updateAdminConfig({ ...adminConfig, allowedLLMs: event.target.value })
  }

  const handleShowTemperature = (event) => {
    console.log(event.target.checked)
    setAdminConfig({ ...adminConfig, showTemperature: event.target.checked })
    updateAdminConfig({ ...adminConfig, showTemperature: event.target.checked })
  }

  const handleAllowedChangingSM = (event) => {
    console.log(event.target.checked)
    setAdminConfig({ ...adminConfig, allowedChangingSM: event.target.checked })
    updateAdminConfig({ ...adminConfig, allowedChangingSM: event.target.checked })
  }

  const handleSaveSystemMessage = () => {
    console.log('Save system message')
    console.log(defaultSystemMessage)
    setAdminConfig({ ...adminConfig, systemMessage: defaultSystemMessage })
    updateAdminConfig({ ...adminConfig, systemMessage: defaultSystemMessage })
  }

  const handleResetSystemMessage = () => {
    console.log('Reset system message')
    setDefaultSystemMessage(adminConfig.systemMessage)
  }

  const handleSaveStartMessage = () => {
    console.log('Save start message')
    setAdminConfig({ ...adminConfig, startMessage: startMessage })
    updateAdminConfig({ ...adminConfig, startMessage: startMessage })
  }

  const handleResetStartMessage = () => {
    console.log('Reset start message')
    setStartMessage(adminConfig.startMessage)
  }

  const handleDefaultTemperature = (event) => {
    console.log(event.target.value)
    setAdminConfig({ ...adminConfig, defaultTemperature: event.target.value[0] })
    updateAdminConfig({ ...adminConfig, defaultTemperature: event.target.value[0] })
  }

  useEffect(() => {
    console.log('Admin config:', adminConfig)
    setStartMessage(adminConfig.startMessage)
    setDefaultSystemMessage(adminConfig.systemMessage)
  }, [isDrawerOpen])

  return (
    <Drawer isOpen={isDrawerOpen} onClose={closeDrawerFunc} title="Admin Settings" icon="settings">
      <div className="admin-drawer-container">
        <div class="one-ux-typography--heading-300">
          Welcome {user}! You are the admin of the {index} chat bot!
        </div>

        <one-ux-field label="Adminstrators">
          <div class="admins">
            {adminConfig.admins.map((admin) => (
              <div class="admin">
                <div class="admin-text">{admin}</div>
                <one-ux-button label="Remove" implicit weight="low" onClick={() => removeAdmin(admin)}>
                  <one-ux-icon icon="remove"></one-ux-icon>
                </one-ux-button>
              </div>
            ))}

            <div className="add-admin">
              <one-ux-field label="Add administrator" compact>
                <one-ux-input
                  placeholder="Enter email..."
                  onChange={handleAdminInput}
                  value={adminInput}></one-ux-input>
              </one-ux-field>
              <one-ux-button label="Add" onClick={handleAddAdmin}>
                <one-ux-icon icon="add"></one-ux-icon>
              </one-ux-button>
            </div>
          </div>
        </one-ux-field>

        <one-ux-checkbox-group
          columns="2"
          class="search-context-checkbox"
          label="Allowed search contexts"
          compact=""
          value={adminConfig.allowedSearchContext}
          options={searchContextOptions}
          onInput={handleChangeAllowedSearchContext}></one-ux-checkbox-group>

        <one-ux-field label="Default search context">
          <one-ux-dropdown placeholder="Choose default searchContext">
            <one-ux-list
              onInput={handleChangeDefaultSearchContext}
              options={searchContextOptions}
              value={[adminConfig.defaultSearchContext]}></one-ux-list>
          </one-ux-dropdown>
        </one-ux-field>

        <one-ux-checkbox-group
          columns="2"
          class="search-context-checkbox"
          label="Allowed LLMs"
          compact=""
          value={adminConfig.allowedLLMs}
          options={llmOptions}
          onInput={handleChangeDefaultLLM}></one-ux-checkbox-group>

        <one-ux-field label="Default Temperature">
          <one-ux-dropdown placeholder="Choose default searchContext">
            <one-ux-list
              onInput={handleDefaultTemperature}
              options={temperatureOptions}
              value={[adminConfig.defaultTemperature]}></one-ux-list>
          </one-ux-dropdown>
        </one-ux-field>

        <one-ux-label label="Show temperature">
          <one-ux-switch onInput={handleShowTemperature} checked={adminConfig.showTemperature}></one-ux-switch>
        </one-ux-label>

        <one-ux-label label="User can change system message">
          <one-ux-switch onInput={handleAllowedChangingSM} checked={adminConfig.allowedChangingSM}></one-ux-switch>
        </one-ux-label>

        <div className="textarea-container">
          <one-ux-field label="Default system message">
            <one-ux-textarea
              line-count="4"
              placeholder="Type your system message here"
              value={defaultSystemMessage}
              onInput={handleSystemMessageChange}></one-ux-textarea>
          </one-ux-field>

          <div className="system-message-buttons">
            <one-ux-button
              label="Save"
              purpose="main"
              onClick={handleSaveSystemMessage}
              disabled={defaultSystemMessage === adminConfig.systemMessage}></one-ux-button>

            <one-ux-button label="Reset" implicit onClick={handleResetSystemMessage}></one-ux-button>
          </div>
        </div>
        <div className="textarea-container">
          <one-ux-field label="Welcome message">
            <one-ux-textarea
              line-count="4"
              placeholder="Type your system message here"
              value={startMessage}
              onInput={handleStartMessageChange}></one-ux-textarea>
          </one-ux-field>

          <div className="system-message-buttons">
            <one-ux-button
              label="Save"
              purpose="main"
              onClick={handleSaveStartMessage}
              disabled={startMessage === adminConfig.startMessage}></one-ux-button>

            <one-ux-button label="Reset" implicit onClick={handleResetStartMessage}></one-ux-button>
          </div>
        </div>
      </div>
    </Drawer>
  )
}
export default AdminDrawer
